import React, { useMemo, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ActionButtonHandle,
  FormPanel,
  RemoteTableField,
  ScrollableSource,
  TableFieldHandle,
  TableFieldToolbarProps,
} from '@eas/common-web';
import { FormTableCount } from '@components/form/table-field/form-table-count';
import { UserRole } from '@models';
import { useUserRoleColumns } from './user-role-columns';
import { UserRoleToolbar } from './user-role-toolbar';

export interface UserRoleFieldProps {
  disabled: boolean;
  source?: ScrollableSource<UserRole>;
}

export function UserRoleField({ disabled, source }: UserRoleFieldProps) {
  const columns = useUserRoleColumns();

  const tableRef = useRef<TableFieldHandle>(null);
  const editRef = useRef<ActionButtonHandle>(null);

  const ToolbarComponent = useMemo(
    () =>
      function Toolbar(props: TableFieldToolbarProps) {
        return <UserRoleToolbar {...props} ref={editRef} disabled={disabled} />;
      },
    [disabled]
  );

  if (!source) {
    return <> Missing USER_ROLE_SOURCE </>;
  }

  return (
    <FormPanel
      label={
        <FormattedMessage
          id="ES__USER_ROLES__PANEL_TITLE"
          defaultMessage="Role"
        />
      }
      expandable={true}
      defaultExpanded={true}
      summary={<FormTableCount source={source} />}
    >
      <RemoteTableField
        ref={tableRef}
        source={source}
        showDetailBtnCond={() => false}
        columns={columns}
        onRowClick={(_, index) => {
          if (!disabled) {
            tableRef.current?.setSelectedIndex(index);
            editRef.current?.executeAction();
          }
        }}
        maxRows={10}
        ToolbarComponent={ToolbarComponent}
        disabled={disabled}
      />
    </FormPanel>
  );
}
